export const EXPANDED_COLUMN_IDS = 'EXPANDED_COLUMN_IDS';
export const updateColumnIds = (data) => ({
  type: EXPANDED_COLUMN_IDS,
  data,
});
